import { render, staticRenderFns } from "./LegacyProjectUserPledges.vue?vue&type=template&id=22369850"
import script from "./LegacyProjectUserPledges.vue?vue&type=script&lang=js"
export * from "./LegacyProjectUserPledges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports